import { useEffect, useMemo, useState } from 'react';
import moment from 'moment/moment';
import useCompanyBusinessTime from './company-business-time/useCompanyBusinessTime';
import { useSelector } from 'react-redux';
import { selectOrderMethod, selectScheduledFor } from '../../store/slices/OrderSlice';

const UPDATE_INTERVAL_TIME = 60_000;

const useIsOrderSlotValidWatcher = () => {
  const [now, setNow] = useState(() => moment());
  const orderMethod = useSelector(selectOrderMethod);
  const scheduledFor = useSelector(selectScheduledFor);
  const date = useMemo(() => (scheduledFor ? moment(scheduledFor) : now), [scheduledFor, now]);
  const { isBusinessTime, isLoading } = useCompanyBusinessTime({
    orderMethod,
  });

  useEffect(() => {
    const interval = setInterval(() => setNow(moment()), UPDATE_INTERVAL_TIME);

    return () => clearInterval(interval);
  }, []);

  const isValidSlot = !isLoading && isBusinessTime(date.toISOString());

  return { isLoading, isValidSlot };
};

export default useIsOrderSlotValidWatcher;
